import { useMatch } from "react-router-dom";

export const usePageNumber = () => {
  const match = useMatch("/:chapter/:subchapter/:page");
  return match?.params.page != null ? +match.params.page : undefined;
};
